
import React, { useState, useEffect } from 'react';

const Overview = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="min-h-screen"
      style={{
        background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)'
      }}
    >
      <div className="px-4 py-8 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">

          {/* Hero Section */}
          <div className={`text-center mb-10 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <h1
              className="text-2xl sm:text-2xl md:text-4xl font-bold mb-2"
              style={{
                color: '#032d86'
              }}
            >
             Reimagining Global Tech Impact Since Day One
            </h1>
           
          </div>

          {/* Company Overview */}
          
          <div className={`mb-8 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <div
              className="rounded-xl p-6 border"
              style={{
                background: '#f9fafb',
                borderColor: '#e5e7eb'
              }}
            >
              <p
                className="text-base font-normal"
                style={{ color: '#222', wordBreak: 'break-word' }}
                          >
                              We are one of the IT services divisions under Kapil Group, delivering technology solutions as Kapil IT Solutions and now as KCS Tech, with over 600 clients served across the last 15 years in India under the Kapil IT Solutions brand. Our diversified portfolio spans domains such as Banking & Finance and Construction.
                              With a global footprint—including sales offices in USA,Singapore,  and Indonesia —we bring all together 150+ consultants across various technology specialties. Our dedicated team focuses on web, mobile app, and software development, empowering modern businesses, particularly in the manufacturing sector and beyond.


              </p>
            </div>
          </div>

          {/* Statistics Grid */}
          <div className={`mb-8 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {[
                { number: '600+', label: 'Clients', color: '#2563eb' },
                { number: '150+', label: 'Consultants', color: '#1e40af' },
                { number: '15+', label: 'Years', color: '#3b82f6' },
                { number: '4', label: 'Global Offices', color: '#60a5fa' }
              ].map((stat, idx) => (
                <div
                  key={idx}
                  className="rounded-lg p-4 border text-center"
                  style={{
                    background: '#f3f4f6',
                    borderColor: '#e5e7eb'
                  }}
                >
                  <div
                    className="text-2xl font-bold mb-1"
                    style={{ color: stat.color }}
                  >
                    {stat.number}
                  </div>
                  <div className="text-sm font-medium" style={{ color: '#222' }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Logos Section */}
          <div className={`mb-8 transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <div
              className="rounded-xl p-6 border"
              style={{
                background: '#f9fafb',
                borderColor: '#e5e7eb'
              }}
            >
              <h3
                className="text-xl sm:text-2xl text-center font-bold mb-4"
                style={{ color: '#08389e' }}
              >
                Our Ecosystem & Certifications
              </h3>
              <div className="flex flex-wrap justify-center items-center gap-6 mb-6">
                {[
                  'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/kapilIT.png?updatedAt=1750758215731',
                  'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/KCS%20TECH_logo.png?updatedAt=1750758410764',
                  'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/kapilitSkillHub.jpg?updatedAt=1750758215735'
                ].map((src, idx) => (
                  <div
                    key={idx}
                    className="rounded-lg p-4 border bg-white flex items-center justify-center"
                    style={{
                      borderColor: '#e5e7eb',
                      minWidth: 100,
                      minHeight: 60
                    }}
                  >
                    <img
                      src={src}
                      alt={`Company Logo ${idx + 1}`}
                      className="h-12 sm:h-16 object-contain"
                      style={{ maxWidth: 120 }}
                    />
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap justify-center items-center gap-6">
                {[
                  {
                    src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/Nasscom.png?updatedAt=1750758215847',
                    alt: 'NASSCOM Certified'
                  },
                  {
                    src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/iso2.png?updatedAt=1750758215744',
                    alt: 'ISO Certified'
                                  }, {
                      src: "https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/Picture2.png?updatedAt=1750758216406",
                      alt:"ISO Certified"
                                  }, {
                      src: "https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/cmmi3.png?updatedAt=1750765075210",
                      alt: "CMMI Level 3 Certified"}
                ].map((logo, idx) => (
                  <div
                    key={idx}
                    className="rounded-lg p-4 border bg-white flex items-center justify-center"
                    style={{
                      borderColor: '#e5e7eb',
                      minWidth: 100,
                      minHeight: 60
                    }}
                  >
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-12 sm:h-16 object-contain"
                      style={{ maxWidth: 120 }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Global Presence */}
          {/* <div className={`text-center transition-all duration-700 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <div
              className="rounded-xl p-6 border"
              style={{
                background: '#f9fafb',
                borderColor: '#e5e7eb'
              }}
            >
              <h3
                className="text-xl sm:text-2xl font-bold mb-2"
                style={{ color: '#2563eb' }}
              >
                Global Presence
              </h3>
              <div className="text-base font-semibold mb-2" style={{ color: '#222' }}>
                🌍 INDONESIA • SINGAPORE • INDIA • USA 🌍
              </div>
              <p className="text-base font-normal mb-2" style={{ color: '#222' }}>
                Creating Value • Cultivating Trust • Catalyzing Innovation
              </p>
              <div className="flex flex-wrap justify-center gap-2">
                {[
                  'Digital Transformation',
                  'Enterprise Solutions',
                  'Global Innovation'
                ].map((tag, idx) => (
                  <span
                    key={idx}
                    className="px-4 py-1 rounded-full font-medium text-sm"
                    style={{
                      background: '#e5e7eb',
                      color: '#2563eb'
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </div>
  );
};

export default Overview;